/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "components/CustomButtons/Button.jsx";
import classNames from 'classnames';

// @material-ui/icons
import { Apps } from "@material-ui/icons";

import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";

const CustomListItem = withStyles({
  root: {
    fontSize: '36px',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.12)',
      color: 'white',
      boxShadow: 'none',
    },
  }
})(ListItem);

function HeaderLinks({ ...props }) {
  const { classes } = props;
  return (
    <List className={classes.list}>
      {props.data.map(res =>
        <CustomListItem key={res.id} className={classes.listItem}>
          <Button
            href={res.link}
            color="transparent"
            target="_self"
            className={classNames(classes.navLink, 'customMenuButtons')}
          >
          {res.title}
          </Button>
        </CustomListItem>
      )}
    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx